import { defineMessages } from "react-intl";
const messages = defineMessages({
    aiDiscoverabilityReceieverEmailLabel: {
        id: "app.admin.aiDiscoverability.receieverEmailLabel",
        defaultMessage: "Receiver Email",
    },
    aiDiscoverabilityReceieverEmailPlaceholder: {
        id: "app.admin.aiDiscoverability.receieverEmailPlaceholder",
        defaultMessage: "Type the Receiver's Email",
    },
    aiDiscoverabilitySubjectNameLabel: {
        id: "app.admin.aiDiscoverability.subjectNameLabel",
        defaultMessage: "Community Name",
    },
    aiDiscoverabilitySubjectNamePlaceholder: {
        id: "app.admin.aiDiscoverability.subjectNamePlaceholder",
        defaultMessage: "Type a community",
    },
    aiDiscoverabilitySubjectAddressLabel: {
        id: "app.admin.aiDiscoverability.subjectAddressLabel",
        defaultMessage: "Community Address",
    },
    aiDiscoverabilitySubjectAddressPlaceholder: {
        id: "app.admin.aiDiscoverability.subjectAddressPlaceholder",
        defaultMessage: "Type an address",
    },
    aiDiscoverabilityAgentModelLabel: {
        id: "app.admin.aiDiscoverability.agentModelLabel",
        defaultMessage: "LLM Agent",
    },
    aiDiscoverabilityModelSelectLabel: {
        id: "app.admin.aiDiscoverability.agentModelSelect",
        defaultMessage: "Select the Agent's Model",
    },
    aiDiscoverabilityAssessmentButtonLabel: {
        id: "app.admin.aiDiscoverability.assessmentButtonLabel",
        defaultMessage: "Run Assessment",
    },
    aiDiscoverabilityValidationAtLeastOneField: {
        id: "app.admin.aiDiscoverability.validation.atLeastOneField",
        defaultMessage: "Enter at a least community's name or an address to continue.",
    },
    aiDiscoverabilityResultsSuccessfulTitle: {
        id: "app.admin.aiDiscoverability.resultsSuccessfulTitle",
        defaultMessage: "Results successfully retrieved",
    },
    aiDiscoverabilityFormTitle: {
        id: "app.admin.aiDiscoverability.formTitle",
        defaultMessage: "Discover a Commmunity's presence on LLMs Agents w/ AI",
    },
});
export default messages;
